import { Component } from '@angular/core';
import { WidgetConfigFormTemplate } from '../widget-config-form-template';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SwitchComponent } from '@app/modules/core/components/switch/switch.component';

@Component({
  selector: 'topo-times-widget-config-form',
  imports: [ReactiveFormsModule, TranslatePipe, SwitchComponent],
  templateUrl: './times-widget-config-form.component.html'
})
export class TimesWidgetConfigFormComponent extends WidgetConfigFormTemplate {}
